<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'default'
    }
  },

  computed: {
    sizeClasses() {
      return {
        small: 'px-4 py-2 text-sm',
        default: 'px-6 py-3'
      }[this.size]
    }
  }
}
</script>

<template>
  <router-link
    v-bind="$attrs"
    class="block tab transition-colors duration-100 border-b-2 border-transparent tab focus:outline-none text-gray-900"
    :class="{
      'cursor-not-allowed opacity-50': disabled,
      'hover:border-orange-mia': !disabled,
      [sizeClasses]: true
    }"
    active-class="border-orange-mia"
    v-on="$listeners"
  >
    <slot />
  </router-link>
</template>

<style scoped>
.tab {
  margin-bottom: calc(theme('spacing.px') * -2);
}
</style>
